<template>
<div class="chapter">
<div class="inner_page">
<div class="book" title="Gil Walsh"><div class="frontmatter"><div class="recto"><h1 class="title"><a id="index"></a>Gil Walsh Interiors</h1><h2 class="subtitle">A Case
                        For Color</h2><h3 class="author">Gil Walsh </h3><h4>with Margaret Reilly
                        Muldoon</h4><img alt="Gibbs Smith Logo" src="images/logo.jpg"/></div><div class="verso"><p class="versotitle">Gil Walsh</p><p class="versotitle">A Case
                        For Color</p><p>Digital Edition 1.0</p><p class="copyright">Text © 2016 Gil
                        Walsh</p><p>Photos copyright as noted throughout</p><p>All rights reserved.
                        No part of this book may be reproduced by any means whatsoever without
                        written permission from the publisher, except brief portions quoted for
                        purpose of review.</p><p class="nobreak">Gibbs Smith</p><p class="nobreak">P.O. Box 667</p><p>Layton, Utah 84041</p><p class="nobreak">Orders:
                        1.800.835.4993</p><p>www.gibbs-smith.com</p><p>ISBN:
                    978-1-4236-4169-8</p></div></div><div class="frontmatter"><div class="dedication" title="Dedication"><p>For my mother</p><p>Mary Gill
                    Moran</p></div></div><div class="frontmatter"><div class="acknowledgements" title="Acknowledgements"><h3>Acknowledgments</h3>
<p>Thanks first to my amazing design team for their talent and limitless
                        enthusiasm; librarian, administration staff, and consultants; they support
                        me every day, in every way, with unconditional love and encouragement that I
                        could not live without. </p>
<p>A special thank-you to all my clients over the years, who trusted me with
                        their most treasured possessions—their homes—and without whom this beautiful
                        book would not be a reality. </p>
<p>Thanks to Andrea Halley-Wright, who handles my social media; to my thousands
                        of followers, who continually respond with their approval and likes; and to
                        the publications that have shown their support by publishing my work. </p>
<p>To everyone who had a hand in the creation and design of this book: all the
                        photographers who captured the spirit and substance of my design in such
                        poignant ways; Steven Stolman, who introduced me to Madge Baird; and
                        everyone at Gibbs Smith who helped to publish A Case For Color; and
                        especially Margaret Reilly Muldoon, who has promoted my work for years and
                        whose amazing memory and talent captured my voice. </p>
<p>To my family and everyone at the firm, you inspire and encourage me every
                        day. I am eternally grateful. </p>
<p>Gil Walsh</p>
</div></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?2ec8640f